
import { cn } from '@jk-core/utils';
import { CalendarRange, CalendarView } from '@/Calendar/type';
import isInRange from '@/Calendar/utils/isInRange';
import isSameDay from '@/Calendar/utils/isSameDay';
import styles from './DayTile.module.scss';

const WEEKS = ['일', '월', '화', '수', '목', '금', '토'];

interface Props {
  hoverDate?:Date | null,
  setHoverDate?:(date:Date | null)=>void,
  selectedDate?: CalendarRange;
  weeksInMonth: {
    thisMonth: string;
    date: Date;
  }[][];
  tileContent?: (date: Date | undefined, view: CalendarView) => React.ReactNode;
  handleDayClick: (day: Date) => void;
  max?: Date;
  min?: Date;
  hideBefore?: boolean;
  hideAfter?: boolean;
  range?: boolean;
  scroll?: boolean;
  style?: React.CSSProperties;
}
export default function DayTile({
  selectedDate, weeksInMonth, tileContent, handleDayClick, range = false,
  max, min, hideBefore = false, hideAfter = false, style, scroll,
  hoverDate, setHoverDate = () => { },
}: Props) {
  const handleDisabled = (date: Date): boolean => {
    const compareDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const compareMin = min ? new Date(min.getFullYear(), min.getMonth(), min.getDate()) : null;
    const compareMax = max ? new Date(max.getFullYear(), max.getMonth(), max.getDate()) : null;

    return !!((compareMin && compareDate < compareMin) || (compareMax && compareDate > compareMax));
  };

  return (
    <div className={styles['day-tile']} style={style}>
      <div className={styles['day-tile__weeks']}>
        {WEEKS.map((week) => (<div className={styles['day-tile__weeks--date']} key={week}>{week}</div>))}
      </div>

      <div className={styles['day-tile__tile']}>
        {weeksInMonth.map((week, index) => (
          <div key={index} className={styles['day-tile__week']}>
            {week.map((day, idx) => (
              <button
                className={cn({
                  [styles['day-tile__day']]: true,
                  [styles['day-tile__day--today']]: isSameDay(day.date, new Date()),
                  [styles['day-tile__day--selected-first']]: !!selectedDate && isSameDay(day.date, selectedDate[0] || null) && range
                    && ((!!selectedDate[1]
                    || ((!scroll && hoverDate != null && !!selectedDate[0])
                      && hoverDate > selectedDate[0]))),
                  [styles['day-tile__day--selected-last']]: (!!selectedDate && isSameDay(day.date, selectedDate[1] || null) && range)
                    || (!scroll && !selectedDate?.[1] && isSameDay(day.date, hoverDate || null)),
                  [styles['day-tile__day--before']]: day.thisMonth !== 'this',
                  [styles['day-tile__day--hide-before']]: hideBefore && day.thisMonth === 'before',
                  [styles['day-tile__day--hide-after']]: hideAfter && day.thisMonth === 'after',
                  [styles['day-tile__day--tile']]: !!(tileContent && tileContent(day.date, 'day')),
                  [styles['day-tile__day--range']]: isInRange(day.date, selectedDate) || (!!selectedDate?.[0] && (isInRange(day.date, [selectedDate[0], hoverDate]))),
                })}
                type="button"
                disabled={handleDisabled(day.date)}
                key={idx}
                onMouseOver={() => {
                  if (!selectedDate?.[1] && !((min && day.date < min) || (max && day.date > max))) {
                    setHoverDate(new Date(
                      day.date.getFullYear(),
                      day.date.getMonth(),
                      day.date.getDate(),
                    ));
                  }
                }}
                onFocus={() => {
                  if (!selectedDate?.[1] && !((min && day.date < min) || (max && day.date > max))) {
                    setHoverDate(new Date(
                      day.date.getFullYear(),
                      day.date.getMonth(),
                      day.date.getDate(),
                    ));
                  }
                }}
                onMouseLeave={() => {
                  if (hoverDate) setHoverDate(null);
                }}
                onClick={() => handleDayClick(day.date)}
              >
                <div className={cn({
                  [styles['day-tile--content']]: true,
                  [styles['day-tile--selected']]: !!selectedDate && (isSameDay(day.date, selectedDate[0] || null) || isSameDay(day.date, selectedDate[1] || null) || isSameDay(day.date, hoverDate || null)),
                  [styles['day-tile--tile']]: !!(tileContent && tileContent(day.date, 'day')),
                })}
                >
                  {day.date.getDate()}
                  {tileContent && tileContent(day.date, 'day')}
                </div>
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
